import { IEntryStateScored } from "../models";

export interface IEntryStateCamera extends IEntryStateScored {
    url?: string;
}

export const cameraEditInfo = {
    editExcludeFields: []
}